<div fxFlex fxFlexFill fxFlexLayout="column" class="container-fluid" *ngIf="subscriber">
  <div class="state">
    <div class="card" class="fxGap-medium-sm">
      <div class="card-body">
        <h2 class="mobile-text-centered mgtp-x-small mgbt-medium-sm">{{ inAdminState ? 'Subscriber\'s' : 'My'}} Plan Enrollment</h2>
        <h3 class="h4 mobile-text-centered">
            <b>This page displays coverage effective as of today.</b>
        </h3>
        <div fxLayout="column">
          <div class="h6" role="heading" aria-level="4">Use this page to:</div>
          <ul>
            <li>View your account information and current plan enrollment.</li>
            <li>View and print Statements of Insurance.</li>
            <li>Subscribe or unsubscribe from HCA email notifications.</li>
          </ul>
        </div>
        <div id="soi-button-container" fxLayout="row wrap" style="padding-bottom:20px;">
          <h3 class="h4" fxFlexFill>
            Select a Statement of Insurance (SOI) button below to download a PDF showing your plan enrollment. You can save or print the PDF. Statements
            of Insurance do not include supplemental life or AD&D insurance, Flexible Spending Arrangement (FSA), Limited Purpose FSA, or Dependent Care
            Assistance Program (DCAP) enrollment. Supplemental life and AD&D enrollment information is available through the MetLife Benefits portal.
          </h3>
          <div>
            <button id="soi-button" type="button" class="btn btn-primary" (click)="exportStatementOfInsurance()">
              <span class="k-icon k-i-print"></span> Current Statement of Insurance
            </button>
            <div style="text-align:left;margin-top:5px;">Shows your currently effective plan enrollment.</div>
          </div>
          <div *ngIf="showOEButton" style="padding-top:10px;border-top:solid 1px lightgrey;margin-top:10px;">
            <button id="soi-button" type="button" class="btn btn-primary" (click)="exportOEStatementOfInsurance()">
              <span class="k-icon k-i-print"></span> {{futureOeButtonLabel}} Statement of Insurance
            </button>
            <div style="padding-top:5px;">Shows the elections you made during annual open enrollment for coverage effective {{futureOeButtonLabel}}.</div>
            <div style="font-style:italic;margin-top:5px;"><b>Important:</b> This statement reflects the elections you made during annual open enrollment. Changes or corrections made after open enrollment may not appear on this statement.</div>
          </div>
        </div>
        <div class="card mgbt-medium">
          <div class="mobile-text-centered card-header"><h4 class="h5">Section A - Subscriber account information</h4></div>
          <summary-overview
            [inAdminState]="inAdminState"
            [subscriber]="subscriber"
            [subscriberModel]="subscriberModel"
            [subscriberContact]="subscriberContact"
            [isFullBenefits]="isFullBenefits"
            (emailSubscriptionUpdated)="updateEmailIndicator($event)"
          ></summary-overview>
        </div>
        <div class="card">
          <div class="mobile-text-centered card-header"><h4 class="h5">Section B - Subscriber and/or dependent coverage information</h4></div>
          <summary-coverage
            [inAdminState]="inAdminState"
            [memberSummary]="subscriber.memberSummary"
            [electablePlanTypesForCurrentPeriod]="electablePlanTypesForCurrentPeriod"
            [spousalCoverageSurcharge]="subscriber.spousalCoverageSurchargeInd"
          ></summary-coverage>
        </div>
      </div>
    </div>
    <pdf #pdf [documentTitleText]="documentTitleText" [documentHeaderText]="documentHeaderText" [documentFooterText]="documentFooterText" aria-hidden="true">
      <coverage-summary [forPdf]="true" [documentTitleText]="documentTitleText" [documentHeaderText]="documentHeaderText" [enrolledHeader]="enrolledHeader" documentFooterText="documentFooterText" [subscriber]="subscriberModel" [summaryObject]="subscriber"></coverage-summary>
    </pdf>
    <pdf #oePdf [documentTitleText]="documentTitleText" [documentHeaderText]="documentHeaderText" [documentFooterText]="documentFooterText" aria-hidden="true">
      <coverage-summary [forPdf]="true" [documentTitleText]="documentTitleText" [documentHeaderText]="documentHeaderText" [enrolledHeader]="enrolledHeader" documentFooterText="documentFooterText" [subscriber]="subscriberModel" [summaryObject]="futureOeSubscriber"></coverage-summary>
    </pdf>
  </div>
</div>
